var _circle, _g, _circle2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader2DStep(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "loader",
    width: 240,
    height: 240,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 40,
    r: 4,
    fill: "#2A2C29"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6571 37.7284H27.3473L25.6827 42.2716H24.9925L26.6571 37.7284Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3173 37.7284H29.0074L27.3429 42.2716H26.6527L28.3173 37.7284Z",
    fill: "#FEFEFF"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 4,
    fill: "#2A2C29"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6571 37.7284H40.3473L38.6827 42.2716H37.9925L39.6571 37.7284Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3173 37.7284H42.0074L40.3429 42.2716H39.6527L41.3173 37.7284Z",
    fill: "#FEFEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.01491,
    height: 4.54318,
    fill: "white",
    transform: "translate(24.9925 37.7284)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.01491,
    height: 4.54318,
    fill: "white",
    transform: "translate(37.9925 37.7284)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader2DStep);
export default __webpack_public_path__ + "static/media/loader_2d-step.9910efb37a234361c58afd259baa8186.svg";
export { ForwardRef as ReactComponent };